// extracted by mini-css-extract-plugin
module.exports = {"root":"index-root-3IQXm","imgDef":"index-imgDef-2BdfF","content":"index-content-3cuVe","naviBarBox":"index-naviBarBox-32Xmp"};